import {splitIntoEqualLines} from "../split-string-to-equal-length-lines";

export default function (mortgage, config) {
    const map = {}, ask = [], errors = []

    const accountDetails = JSON.parse(mortgage.requirement.ddBankAccountDetails || '{}')


    ask.push({
        label: 'Mandate Reference',
        name: 'mandate-ref',
        type: 'TEXT',
        group: 'DD'
    })
    if (config.hasOwnProperty('mandate-ref')){
        map['mandate-ref'] = config['mandate-ref']
    }


    ask.push({
        label: 'Application Number',
        name: 'application-no',
        type: 'TEXT',
        group: 'DD'
    })
    if (config.hasOwnProperty('application-no')){
        map['application-no'] = config['application-no']
    }


    ask.push({
        label: 'Customer Name',
        name: 'customerName',
        type: 'TEXT',
        group: 'DD'
    })
    map['your-name'] = config.customerName ?? accountDetails.name ?? mortgage.applicant1.fullName
    if (!map['your-name']){
        errors.push('No Name')
    }


    ask.push({
        label: 'Customer Address 1',
        name: 'customer-address-1',
        type: 'TEXT',
        group: 'DD'
    })
    ask.push({
        label: 'Customer Address 2',
        name: 'customerAddress-2',
        type: 'TEXT',
        group: 'DD'
    })
    if (config['customer-address-1']){
        map['address-1'] = config['customer-address-1']
    }
    else{
        const lines = splitIntoEqualLines(accountDetails.address||'')
        map['address-1'] = lines[0] || ''
        map['address-2'] = lines[1] || ''
    }
    if (config['customer-address-1'] && config['customer-address-2']){
        map['address-2'] = config['customer-address-2']
    }
    if (!map['address-1']){
        errors.push('No Address')
    }


    ask.push({
        name: 'bic',
        label: 'BIC',
        type: 'TEXT',
        group: 'DD'
    })
    if (config.hasOwnProperty('bic')) {
        map['bic'] = config['bic'].toUpperCase()
    } else if(accountDetails.bic){
        map['bic'] = accountDetails.bic.toUpperCase()
    } else {
        errors.push('No BIC')
    }


    ask.push({
        label: 'IBAN',
        name: 'iban',
        type: 'TEXT',
        group: 'DD'
    })
    if (config.hasOwnProperty('iban')) {
        map['iban'] = config['iban'].toUpperCase()
    } else if(accountDetails.iban){
        map['iban'] = accountDetails.iban.toUpperCase()
    } else {
        errors.push('No IBAN')
    }

    ask.push({
        label:'Application No'
        , name:'application-no'
        , type:'TEXT'
        , group:'DD'
    })
    if (config.hasOwnProperty('application-no')){
        map['apploication-no'] = config['application-no']
    }
    else if (mortgage.activeSubmission.mortgageAccountNo){
        map['application-no'] = mortgage.activeSubmission.mortgageAccountNo
    }
    else{
        errors.push('No Application No')
    }

    map['type-of-payment'] = true


    return {sections:[{map, ask, errors}]}




}